import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

import {
  getAdherentFullName,
  getUniqueOptions,
} from "../utils/groupResultsUtils";

function CoachResultsFilters({
  groups = [],
  approvedAdherents = [],
  results = [],
  filters,
  onChange,
  onReset,
}) {
  const eventOptions = getUniqueOptions(
    results,
    (result) => result.event?.titre,
    (result) => result.event?.titre,
  );

  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 sm:p-5 pt-6">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-orange-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.14em] text-orange-700 dark:bg-orange-500/10 dark:text-orange-200">
            <FaFilter />
            Filtres
          </div>

          <h2 className="mt-3 font-titre text-xl font-bold text-slate-950 dark:text-white">
            Trouver rapidement une compétition
          </h2>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-600 transition hover:border-red-200 hover:text-red-600 dark:border-white/10 dark:bg-white/[0.05] dark:text-white/70"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="mt-5 grid gap-3 lg:grid-cols-5">
        <label className="relative block lg:col-span-2">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            type="search"
            value={filters.search}
            onChange={(event) => onChange("search", event.target.value)}
            placeholder="Rechercher un judoka, groupe, compétition..."
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-11 pr-4 text-sm font-bold text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-orange-300 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-orange-300/50 dark:focus:ring-orange-500/10"
          />
        </label>

        <select
          value={filters.adherentId}
          onChange={(event) => onChange("adherentId", event.target.value)}
          className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-orange-300 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-orange-300/50 dark:focus:ring-orange-500/10"
        >
          <option value="">Tous les judokas</option>
          {approvedAdherents.map((adherent) => (
            <option
              key={`${adherent.groupId}-${adherent.id}`}
              value={adherent.id}
            >
              {getAdherentFullName(adherent)}
            </option>
          ))}
        </select>

        <select
          value={filters.groupId}
          onChange={(event) => onChange("groupId", event.target.value)}
          className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-orange-300 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-orange-300/50 dark:focus:ring-orange-500/10"
        >
          <option value="">Tous les groupes</option>
          {groups.map((group) => (
            <option key={group.id} value={group.id}>
              {group.nom}
            </option>
          ))}
        </select>

        <select
          value={filters.status}
          onChange={(event) => onChange("status", event.target.value)}
          className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-orange-300 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-orange-300/50 dark:focus:ring-orange-500/10"
        >
          <option value="all">Tous</option>
          <option value="filled">Résultats saisis</option>
          <option value="empty">À compléter</option>
        </select>

        <select
          value={filters.eventTitle}
          onChange={(event) => onChange("eventTitle", event.target.value)}
          className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-orange-300 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-orange-300/50 dark:focus:ring-orange-500/10 lg:col-span-5"
        >
          <option value="">Toutes les compétitions</option>
          {eventOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </section>
  );
}

export default CoachResultsFilters;
